<script>
	// Components
	import StepInputFloat from '@/Components/StepInputFloat.svelte';
	// Services
	import { nextLadderPrice, NumberTransform } from '@/Services/Helpers.js';
	// Constants
	import { PriceLadder } from '@/Constants/Prices.js';

	export let selection;
	export let value;
	export let width = 'w-14';
	export let isEditingPrices = false;
	export let onEnter = false;
	export let isManual = false;
	export let compact = false;
	export let tabindex;

	window.nextLadderPrice = nextLadderPrice;
	window.PriceLadder = PriceLadder;

	let newOverridePrice;
	$: overridePrice =
		selection && selection.override_price
			? NumberTransform(selection.override_price)
			: NumberTransform(selection.price);
	$: (newOverridePrice || overridePrice) && calcOverride();
	$: !isEditingPrices && calcOverride();

	function calcOverride() {
		if (isManual) {
			value = newOverridePrice;
		}
		if (!isEditingPrices || (overridePrice && !newOverridePrice)) {
			value = overridePrice;
			newOverridePrice = overridePrice;
		} else if (newOverridePrice) {
			value = newOverridePrice;
		}
	}

	function setClosest(direction) {
		try {
			newOverridePrice = nextLadderPrice(newOverridePrice, direction).toFixed(2);
		} catch (err) {
			//either at the upper or lower limits of available prices.
		}
	}
</script>

<StepInputFloat
	bind:value={newOverridePrice}
	{compact}
	{tabindex}
	inputWidth={width}
	highlight={isManual}
	bgHighlight={overridePrice != newOverridePrice}
	on:updated={() => (isEditingPrices = true)}
	on:inc={() => setClosest('up')}
	on:dec={() => setClosest('down')}
	on:enter={() => onEnter && onEnter()}
/>
